export const patternContext = contexts => {
    let array = [];
    contexts.forEach((context) => {
        array.push({
            id: context.id,
            name: context.codigo,
            type: context.tipo,
            label: context.variavel,
            value: context.valor ? context.valor : '',
            ordem: context.ordemExibicao,
            legenda: context.legenda,
            grupoExibicao: context.agrupamento,
        });
    })
    return array;
}